// ═══════════════════════════════════════════════════════════════════════════════
// Auto-generated task titles for pickup/drop-off & medication reminder wizards
// ═══════════════════════════════════════════════════════════════════════════════
const normalizeLocale = (locale) => {
    if (locale === 'id') {
        return 'id';
    }
    if (locale === 'fil' || locale === 'tl') {
        return 'fil';
    }
    if (locale === 'en' || locale.startsWith('en-')) {
        return 'en';
    }
    if (locale === 'zh-Hans' || locale.startsWith('zh-Hans') || locale === 'zh-CN') {
        return 'zh-Hans';
    }
    return 'zh-Hant';
};
const usesEnglishTitlePattern = (localeKey) => localeKey === 'en' || localeKey === 'id' || localeKey === 'fil';
export const buildPickupDropoffAutoTitle = (params) => {
    const localeKey = normalizeLocale(params.locale);
    const name = params.personName.trim();
    const loc = params.location.trim();
    if (usesEnglishTitlePattern(localeKey)) {
        if (params.leg === 'pickup') {
            return loc !== '' ? `Pick up ${name} at ${loc}` : `Pick up ${name}`;
        }
        return loc !== '' ? `Take ${name} to ${loc}` : `Take ${name}`;
    }
    if (localeKey === 'zh-Hans') {
        if (params.leg === 'pickup') {
            return loc !== '' ? `到${loc}接${name}` : `接${name}`;
        }
        return loc !== '' ? `送${name}到${loc}` : `送${name}`;
    }
    if (params.leg === 'pickup') {
        return loc !== '' ? `到${loc}接${name}` : `接${name}`;
    }
    return loc !== '' ? `送${name}到${loc}` : `送${name}`;
};
export const buildMedicationReminderAutoTitle = (params) => {
    const localeKey = normalizeLocale(params.locale);
    const name = params.personName.trim();
    if (usesEnglishTitlePattern(localeKey)) {
        return `${name} needs to take medication`;
    }
    if (localeKey === 'zh-Hans') {
        return `${name}需要食药`;
    }
    return `${name}需要食藥`;
};
export const formatTaskGroupNotificationTitleList = (titles) => titles.map((t) => t.trim()).filter((t) => t !== '').join(' , ');
//# sourceMappingURL=taskGroupTitles.js.map